import React from 'react';
import Truncate from '../../../../../components/Truncate';
import CustomTag from '../../../../../components/CustomTag';
import './styles.css';

const Slogan = ({ tag = 'h2', children }) => {
  if (!children) return '';
  return (
    <CustomTag tag={tag} className="Listview__Card__slogan">
      <Truncate lines={1}>
        <span>{children}</span>
      </Truncate>
    </CustomTag>
  );
};

export default Slogan;
